<template>
  <div class="grid grid-cols-2 gap-4">
    <SalesSummaryCard
      :card="card"
      @click="$emit('navigateTab', 'sales')"
    />
    <FamiliesSummaryCard
      :products-report="card?.productsReport"
      @click="$emit('navigateTab', 'families')"
    />
    <ClientTypesSummaryCard
      :client-types-report="card?.clientTypesReport"
      :loading="clientTypesLoading"
      :tax-key="taxKey"
      :center="center"
      @click="$emit('navigateTab', 'clientTypes')"
    />
    <ClientsSummaryCard
      :clients-report="card?.clientsReport"
      :loading="clientsLoading"
      @click="$emit('navigateTab', 'clients')"
    />
    <MembersSummaryCard
      class="col-span-2"
      :members-report="card?.membersReport"
      :members-conversion-data="membersConversionData"
      :loading="membersLoading"
      @click="$emit('navigateTab', 'members')"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, inject, type Ref } from 'vue'
import { useReportContext } from '../../../composables/useReportContext'
import { useAppSettingsStore } from '../../../stores/AppSettingsStore'
import SalesSummaryCard from '../../report-sections/SalesSummaryCard.vue'
import FamiliesSummaryCard from '../../report-sections/FamiliesSummaryCard.vue'
import ClientTypesSummaryCard from '../../report-sections/ClientTypesSummaryCard.vue'
import ClientsSummaryCard from '../../report-sections/ClientsSummaryCard.vue'
import MembersSummaryCard from '../../report-sections/MembersSummaryCard.vue'
import type { MembersStatsResponse } from '../../../responses'
import type { TaxDataKey } from '../../../responses'

defineEmits<{
  navigateTab: [key: string]
}>()

const { card, centerId } = useReportContext()
const appSettingsStore = useAppSettingsStore()

const membersConversionData = inject<Ref<MembersStatsResponse | null>>('reportMembersConversionData')

const center = computed(() => {
  return appSettingsStore.getCenter(centerId)
})

const taxKey = computed<TaxDataKey>(() => {
  return card.value?.taxIncluded ? 'included_tax' : 'excluded_tax'
})

const clientTypesLoading = computed(() => {
  return card.value?.clientTypesReport == null
})

const clientsLoading = computed(() => {
  return card.value?.clientsReport == null
})

const membersLoading = computed(() => {
  return card.value?.membersReport == null
})
</script>
